import { render, staticRenderFns } from "./TicketControls.vue?vue&type=template&id=08be95d8"
import script from "./TicketControls.vue?vue&type=script&lang=js"
export * from "./TicketControls.vue?vue&type=script&lang=js"
import style0 from "./TicketControls.vue?vue&type=style&index=0&id=08be95d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports